module.exports = __webpack_public_path__ + "static/media/close-menu-mobile.13018cfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-menu-mobile.svg
// module id = 147
// module chunks = 0